// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Browser } from "@capacitor/browser";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { SupportArticles, type SupportContext } from "@src/appV2/support/constants";

export interface ContactSupportButtonProps {
  supportContext: SupportContext;
  children: string;
  supportLink: string;
}

export function ContactSupportButton(props: ContactSupportButtonProps) {
  const { supportContext, children = "Contact Support", supportLink } = props;

  const handleClick = async () => {
    await Browser.open({
      url: supportLink,
      windowName: "_blank",
      presentationStyle: "popover",
    });
    logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
      articleLink: supportLink,
      articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
      supportContext,
    });
  };

  return (
    <Button fullWidth variant="outlined" size="large" onClick={handleClick}>
      {children}
    </Button>
  );
}
